export default __webpack_public_path__ + "static/media/Necklace of Freezing Gale.de98a195.jpg";